import { Component, computed, inject } from '@angular/core';
import { AuthService } from 'shared-library';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { PortalTranslationService } from '../../core/services/portal-translation.service';

@Component({
  selector: 'investigator-session-timeout',
  standalone: true,
  imports: [DialogModule, ButtonModule],
  template: `
    <p-dialog
      [visible]="auth.isSessionExpired()"
      [modal]="true"
      [closable]="false"
      [closeOnEscape]="false"
      [dismissableMask]="false"
      [draggable]="false"
      [resizable]="false"
      [header]="text('Your session is about to end', 'Η συνεδρία σας πρόκειται να λήξει')"
      [style]="{ width: '26rem', maxWidth: 'calc(100vw - 2rem)' }">
      <p class="m-0" role="alert">
        {{ text('You will be signed out in', 'Θα αποσυνδεθείτε σε') }}
        <strong>{{ minutes() }}:{{ seconds() }}</strong>
        {{ text('unless you continue.', 'εκτός αν συνεχίσετε.') }}
      </p>
      <ng-template pTemplate="footer">
        <p-button [label]="text('Sign out', 'Αποσύνδεση')" severity="secondary" [text]="true" (onClick)="auth.logout()" />
        <p-button [label]="text('Continue', 'Συνέχεια')" icon="pi pi-refresh" (onClick)="continueSession()" />
      </ng-template>
    </p-dialog>
  `,
})
export class SessionTimeoutComponent {
  readonly auth = inject(AuthService);
  private readonly translation = inject(PortalTranslationService);

  readonly minutes = computed(() => Math.floor(Math.ceil(this.auth.timeLeft() / 1000) / 60));
  readonly seconds = computed(() => String(Math.ceil(this.auth.timeLeft() / 1000) % 60).padStart(2, '0'));

  text(en: string, el: string): string {
    return this.translation.currentLanguage() === 'el' ? el : en;
  }

  continueSession(): void {
    this.auth.refreshToken().subscribe();
  }
}
